export default __webpack_public_path__ + "static/media/Buy.c975a899.svg";